import { Banner, Flex, Header, Icon, Text } from '@driftt/dds'
import { faTriangleExclamation } from '@driftt/dds.icons/regular/faTriangleExclamation'
import React from 'react'

interface PlaybookPriorityAccessWarningProps {
  onClose: () => void
}

const PlaybookPriorityAccessWarning = ({
  onClose,
}: PlaybookPriorityAccessWarningProps) => (
  <Banner.Root variant="warning" onClose={onClose}>
    <Banner.Content>
      <Flex direction="column" alignItems="center">
        <Header variant="h4">
          <Icon icon={faTriangleExclamation} size="small"></Icon> Playbook
          priority
        </Header>

        <Text variant="body" css={{ textAlign: 'center' }}>
          Playbook priority is now set globally across all workspaces within
          your Drift instance. The following table only includes playbooks you
          have access to so some priority <br />
          numbers may not appear. To view hidden playbooks, please contact your
          admin to expand workspace access.
        </Text>
      </Flex>
    </Banner.Content>
  </Banner.Root>
)

export default PlaybookPriorityAccessWarning
